"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * NWG.Commerce.Microshop - Api
 * NWG.Commerce.Microshop - Api functionality
 *
 * The version of the OpenAPI document: NWG.Commerce.Microshop - Api
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.StripeCreateCheckoutSessionResponseToJSON = exports.StripeCreateCheckoutSessionResponseFromJSONTyped = exports.StripeCreateCheckoutSessionResponseFromJSON = exports.instanceOfStripeCreateCheckoutSessionResponse = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the StripeCreateCheckoutSessionResponse interface.
 */
function instanceOfStripeCreateCheckoutSessionResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfStripeCreateCheckoutSessionResponse = instanceOfStripeCreateCheckoutSessionResponse;
function StripeCreateCheckoutSessionResponseFromJSON(json) {
    return StripeCreateCheckoutSessionResponseFromJSONTyped(json, false);
}
exports.StripeCreateCheckoutSessionResponseFromJSON = StripeCreateCheckoutSessionResponseFromJSON;
function StripeCreateCheckoutSessionResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'clientSecret': !(0, runtime_1.exists)(json, 'clientSecret') ? undefined : json['clientSecret'],
        'stripeAccountId': !(0, runtime_1.exists)(json, 'stripeAccountId') ? undefined : json['stripeAccountId'],
    };
}
exports.StripeCreateCheckoutSessionResponseFromJSONTyped = StripeCreateCheckoutSessionResponseFromJSONTyped;
function StripeCreateCheckoutSessionResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'clientSecret': value.clientSecret,
        'stripeAccountId': value.stripeAccountId,
    };
}
exports.StripeCreateCheckoutSessionResponseToJSON = StripeCreateCheckoutSessionResponseToJSON;
